<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>

  <div class="d-flex justify-content-between align-items-center">
    <h3>Customer Information</h3>
    <div class="d-flex justify-content-end align-items-center">
      <div class="d-flex align-items-center gap-10">
        <span>Account active </span>
        <div class="form-check form-switch">
          <input
            [(ngModel)]="model.enabled"
            formControlName="enabled"
            type="checkbox"
            class="form-check-input medium"
            (change)="onEnabledToggled()"
            [disabled]="loading" />
        </div>
      </div>
      <button *ngIf="isConvertToSubaccount()" class="btn btn-outline-primary ms-25" (click)="onClickConvertToSubaccount()">
        Convert to subaccount
      </button>
    </div>
  </div>

  <div class="section">
    <h4 class="mb-25 fw-[400]">Profile info</h4>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Full Name </label>
        <input [(ngModel)]="model.fullName" formControlName="fullName" type="text" class="form-control" />
        <input-errors [control]="form.controls.fullName" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100">
        <label class="form-label required">Username </label>
        <input [(ngModel)]="model.username" formControlName="username" type="text" class="form-control" />
        <input-errors [control]="form.controls.username" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Phone </label>
        <input [(ngModel)]="model.phone" formControlName="phone" type="text" class="form-control" />
        <input-errors [control]="form.controls.phone" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100">
        <label class="form-label required" for="email">Email </label>

        <div class="email-input-wrap">
          <input
            (blur)="onEmailBlur()"
            id="email"
            [(ngModel)]="model.email"
            formControlName="email"
            type="email"
            class="form-control email-input"
            required />
          <label class="verify-toggle input-check">
            <input type="checkbox" class="form-check-input" [(ngModel)]="model.emailVerified" formControlName="emailVerified" />
            <span>Email Verified</span>
          </label>
        </div>

        <input-errors [control]="form.controls.email" [service]="validationService"> </input-errors>
      </div>
    </div>

    <div class="apply-button d-flex justify-content-end mt-25" *ngIf="model?.id">
      <button
        type="button"
        (click)="applyProfileChanges()"
        [disabled]="!isProfileSectionValid() || (convertedToSubaccount && !model?.parent)"
        class="btn btn-primary">
        Apply changes
      </button>
    </div>
  </div>

  <div class="section">
    <h4 class="mb-25 fw-[400]">Company Details</h4>
    <app-zoho-customer-link *ngIf="model?.userRole === 'deputy'" [showLinks]="false" [model]="model"
      [original]="savedModelSnapshot" [parent]="parentUser"></app-zoho-customer-link>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Company name </label>
        <div class="email-input-wrap">
          <input [(ngModel)]="model.companyName" formControlName="companyName" type="text" class="form-control" />
          <label class="verify-toggle input-check" *ngIf="model.companyDetailsVerified">
            <input type="checkbox" class="form-check-input" [(ngModel)]="model.companyDetailsVerified" formControlName="companyDetailsVerified" />
            <span>Company Details Verified</span>
          </label>
        </div>
        <input-errors [control]="form.controls.companyName" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100">
        <label class="form-label">Website</label>
        <input [(ngModel)]="model.websiteUrl" formControlName="websiteUrl" type="text" class="form-control" />
        <input-errors [control]="form.controls.websiteUrl" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Country </label>
        <select [(ngModel)]="model.countryCode" (change)="onCountryEdited(model.countryCode)" formControlName="countryCode" class="form-control">
          <option *ngFor="let country of countries" [value]="country.code">{{ country.name }}</option>
        </select>
        <input-errors [control]="form.controls.countryCode" [service]="validationService"></input-errors>
      </div>

      <div class="form-group w-100 d-flex gap-15">
        <div class="form-group w-50">
          <label class="form-label">State</label>
          <div>
            <input [(ngModel)]="model.addressState" formControlName="addressState" type="text" class="form-control" />
            <input-errors [control]="form.controls.addressState" [service]="validationService"></input-errors>
          </div>
        </div>
        <div class="form-group w-50">
          <label class="form-label required">City </label>
          <div>
            <input [(ngModel)]="model.addressCity" formControlName="addressCity" type="text" class="form-control" />
            <input-errors [control]="form.controls.addressCity" [service]="validationService"></input-errors>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Street </label>
        <input [(ngModel)]="model.addressStreet" formControlName="addressStreet" type="text" class="form-control" />
        <input-errors [control]="form.controls.addressStreet" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100">
        <label class="form-label">Zip</label>
        <input [(ngModel)]="model.addressZip" formControlName="addressZip" type="text" class="form-control" />
        <input-errors [control]="form.controls.addressZip" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label d-flex align-items-center" [ngClass]="{ required: getVatNumberRequired() }">
          VAT number
          <span
            *ngIf="vatValidationIndicator"
            class="fas fa-circle fs-6 ms-0_5"
            [ngClass]="{
              'text-success-s2': vatValidationIndicator === 'verified',
              'text-error-r2': vatValidationIndicator === 'failed',
            }"
            [tooltip]="vatValidationTooltip"
            [tooltipPlacement]="'right'"></span>
        </label>
        <div class="d-flex gap-10">
          <input [(ngModel)]="model.vatNumber" formControlName="vatNumber" type="text" class="form-control" (input)="onVatIdentityChanged()" />
          <button
            *ngIf="canValidateVatManually"
            type="button"
            class="btn btn-outline-primary px-20 text-nowrap"
            [disabled]="vatValidationLoading"
            (click)="validateVatManually()"
            aria-label="Retry VAT verification"
            tooltip="Retry VAT verification"
            [tooltipPlacement]="'right'">
            <span class="icon-refresh fs-4"></span>
          </button>
        </div>
        <input-errors [control]="form.controls.vatNumber" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100">
        <label class="form-label">Business unit/department</label>
        <input [(ngModel)]="model.departmentName" formControlName="departmentName" type="text" class="form-control" />
        <input-errors [control]="form.controls.departmentName" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="company-settings-grid mb-25" *ngIf="showVatExemption() || showZohoCustomerSettings">
      <div class="form-group" *ngIf="showVatExemption()">
        <label class="input-check d-flex align-items-center gap-0_5">
          <input [(ngModel)]="model.vatExempt" formControlName="vatExempt" type="checkbox" class="form-check-input" />
          <span>German VAT exemption approved</span>
        </label>
      </div>
      <app-zoho-customer-link *ngIf="showZohoCustomerSettings" [settings]="zohoSettings" [model]="model"
        [original]="savedModelSnapshot" [showLinks]="zohoSettingsLoaded"></app-zoho-customer-link>
      <ng-container *ngIf="showZohoCustomerSettings && zohoSettingsLoaded">

        <div class="form-group">
          <label class="form-label">Payment due period</label>
          <select [(ngModel)]="zohoSettings.paymentTermsDays" [ngModelOptions]="{ standalone: true }" class="form-control">
            <option *ngFor="let days of [30, 45, 60]" [ngValue]="days">{{ paymentTermsLabel(days) }}</option>
          </select>
        </div>

        <div class="form-group">
          <label class="input-check d-flex align-items-center gap-0_5">
            <input [(ngModel)]="zohoSettings.zohoSyncEnabled" [ngModelOptions]="{ standalone: true }" type="checkbox" class="form-check-input" />
            <span>Sync this account with Zoho</span>
          </label>
          <div class="form-text">Turning this off prevents customer updates and invoice creation for this account.</div>
        </div>
      </ng-container>
    </div>

    <div class="apply-button d-flex justify-content-end mt-25 gap-25" *ngIf="model?.id && model.userRole !== 'subaccount'">
      <button
        *ngIf="model.id"
        type="button"
        [disabled]="loading || model.companyDetailsVerified || !areCompanyFieldsValid() || (showZohoCustomerSettings && zohoSettingsLoading)"
        class="btn btn-primary"
        (click)="verifyCompanyDetails($event)">
        Verify company details
      </button>
      <button type="button" (click)="applyCompanyChanges()" [disabled]="loading || !isCompanySectionValid()" class="btn btn-primary">
        Apply changes
      </button>
    </div>
  </div>

  <div class="section">
    <h4 class="mb-25 fw-[400]">Legal &amp; Operational Contacts</h4>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Data Protection Officer (DPO) Email </label>
        <input [(ngModel)]="model.dataProtectionOfficerEmail" formControlName="dataProtectionOfficerEmail" type="email" class="form-control" />
        <input-errors [control]="form.controls.dataProtectionOfficerEmail" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100">
        <label class="form-label">Legal Representative Email </label>
        <input [(ngModel)]="model.legalRepresentativeEmail" formControlName="legalRepresentativeEmail" type="email" class="form-control" />
        <input-errors [control]="form.controls.legalRepresentativeEmail" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label">Procurement/Routing Email </label>
        <input [(ngModel)]="model.procurementEmail" formControlName="procurementEmail" type="email" class="form-control" />
        <input-errors [control]="form.controls.procurementEmail" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="apply-button d-flex justify-content-end mt-25" *ngIf="model?.id && model.userRole !== 'subaccount'">
      <button type="button" (click)="applyLegalContactsChanges()" [disabled]="!isLegalContactsSectionValid()" class="btn btn-primary">
        Apply changes
      </button>
    </div>
  </div>

  <div class="section" *ngIf="model.userRole !== 'subaccount'">
    <h4 class="mb-25 fw-[400]">Platform settings</h4>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100" *ngIf="canEditInvoiceRecipients()">
        <div class="d-flex justify-content-start">
          <label class="form-label">Invoice emails</label>
          <span
            class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
            [tooltip]="'Comma-separated email addresses that should receive invoices. The account email is used when this list is empty.'"
            [tooltipPlacement]="'right'"></span>
        </div>
        <input [(ngModel)]="invoiceEmails" formControlName="invoiceEmails" type="text" class="form-control" [readonly]="!invoiceRecipientsLoaded" />
        <input-errors [control]="form.controls.invoiceEmails" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100">
        <div class="d-flex justify-content-start">
          <label class="form-label">Default SMS TTL</label>
          <span
            class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
            [tooltip]="
              'Time-to-live value determines how long (in minutes) the system will wait for a final receipt status for test SMS before considering it as a negative. Default value applies to all related accounts but can be changed in Settings of LNT test.'
            "
            [tooltipPlacement]="'right'"></span>
        </div>
        <div class="input-group">
          <input [(ngModel)]="model.testTtl" formControlName="testTtl" type="text" class="form-control" />
          <span class="d-flex justify-content-center align-items-center input-group-text">min</span>
        </div>
        <input-errors [control]="form.controls.testTtl" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25" *ngIf="model.paymentType === 'PREPAID'">
      <div class="form-group w-100">
        <label class="form-label">Low Balance Alert Email</label>
        <input [(ngModel)]="model.emailForAlert" formControlName="emailForAlert" type="email" class="form-control" />
        <input-errors [control]="form.controls.emailForAlert" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100">
        <label class="form-label">Minimal Balance Amount</label>
        <div class="input-group">
          <input [(ngModel)]="model.minBalance" formControlName="minBalance" type="number" class="form-control" />
          <span class="d-flex justify-content-center align-items-center input-group-text">&euro;</span>
        </div>
        <input-errors [control]="form.controls.minBalance" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Password </label> <span *ngIf="form.controls.password.pending" class="icon-wait spin mx-0_5"></span>
        <input [(ngModel)]="model.password" formControlName="password" type="password" class="form-control" />
        <input-errors [control]="form.controls.password" [service]="validationService"></input-errors>
      </div>
      <div *ngIf="showBackupTests()" class="form-group w-100">
        <label class="form-label">Backup tests</label>
        <div class="form-check form-switch">
          <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.testRetriesEnabled" formControlName="testRetriesEnabled" />
        </div>
      </div>
    </div>

    <div class="apply-button d-flex justify-content-end mt-25" *ngIf="model?.id">
      <button type="button" (click)="applyPlatformChanges()" [disabled]="!isPlatformSectionValid()" class="btn btn-primary">Apply changes</button>
    </div>
  </div>

  <div class="section">
    <h3 class="mb-25 fw-[400]">Internal Information</h3>
    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100" *ngIf="model.userRole === 'subaccount'">
        <label class="form-label required">Parent account </label>
        <div class="input-wrapper">
          <input
            formControlName="parentId"
            type="text"
            class="form-control fake-input"
            [value]="parentUser ? parentUser.email + ' <' + parentUser.username + '>' : ''"
            placeholder="Choose parent account"
            readonly
            (click)="showUserListModal('parent')" />
        </div>
        <input-errors [control]="form.controls.parentId" [service]="validationService"></input-errors>
      </div>

      <div class="form-group w-100">
        <label class="form-label">Owner</label>
        <div class="input-wrapper">
          <input
            type="text"
            class="form-control fake-input"
            formControlName="ownerId"
            [value]="ownerUser ? ownerUser.email + ' <' + ownerUser.username + '>' : ''"
            placeholder="Choose owner"
            readonly
            (click)="showUserListModal('owner')" />
        </div>
      </div>

      <div class="form-group w-100" *ngIf="model.userRole !== 'subaccount'">
        <label class="form-label">Converted By</label>
        <div class="input-wrapper">
          <input
            type="text"
            class="form-control fake-input"
            [value]="convertedByUser ? convertedByUser.email + ' <' + convertedByUser.username + '>' : ''"
            placeholder="Choose user"
            readonly
            (click)="showUserListModal('convertedBy')" />
        </div>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25" *ngIf="model.userRole !== 'subaccount'">
      <div class="form-group w-100" *ngIf="model.userRole === 'deputy'">
        <label class="form-label">Parent account</label>
        <div class="input-wrapper">
          <input
            formControlName="parentId"
            type="text"
            class="form-control fake-input"
            [value]="parentUser ? parentUser.email + ' <' + parentUser.username + '>' : ''"
            placeholder="Choose parent account"
            readonly
            (click)="showUserListModal('parent')" />
        </div>
      </div>
      <div class="form-group w-100">
        <label class="form-label">Source</label>
        <select [(ngModel)]="model.source" formControlName="source" class="form-control form-select">
          <option *ngFor="let source of service.sourceItems" [value]="source.id">
            {{ source.label }}
          </option>
        </select>
        <input-errors [control]="form.controls.source" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100" *ngIf="showRankingIndex()">
        <label class="form-label">Ranking index</label>
        <input [(ngModel)]="model.rankingIndex" formControlName="rankingIndex" type="text" class="form-control" />
        <input-errors [control]="form.controls.rankingIndex" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div *ngIf="!showParent()" class="form-group w-100">
        <label class="form-label required">Payment Type </label>
        <select [(ngModel)]="model.paymentType" formControlName="paymentType" class="form-control form-select">
          <option *ngFor="let type of types" [value]="type.id">
            {{ type.title }}
          </option>
        </select>
        <input-errors [control]="form.controls.paymentType" [service]="validationService"></input-errors>
      </div>
      <div *ngIf="showComment()" class="form-group w-100">
        <label class="form-label">Comment/Note</label>
        <div class="input-group">
          <textarea rows="4" [(ngModel)]="model.comment" formControlName="comment" class="form-control"></textarea>
        </div>
        <input-errors [control]="form.controls.comment" [service]="validationService"></input-errors>
      </div>
    </div>

    <div *ngIf="model?.id && showInternalInformationApplyChanges()" class="apply-button d-flex justify-content-end mt-25">
      <button type="button" (click)="applyInternalChanges()" [disabled]="!isInternalSectionValid()" class="btn btn-primary">Apply changes</button>
    </div>
  </div>

  <div class="d-flex justify-content-end align-items-center gap-15">
    <button class="btn btn-outline-danger px-25" (click)="onCancel()">Cancel</button>
    <button *ngIf="!model?.id" type="submit" [disabled]="!form.valid" class="btn btn-primary px-25">Create user</button>
  </div>
</form>

<ng-template #userListModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Select user</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-users-select
      [multiple]="false"
      [roles]="selectUserMode === 'parent' ? ['mainaccount'] : ['admin', 'manager']"
      (selectUser)="onSelectParentUser($event)"></app-users-select>
  </div>
</ng-template>

<ng-template #verifyCompanyDetailsTpl let-dialogRef="dialogRef">
  <deletemodal [message]="messageForModal" [dialogRef]="dialogRef"></deletemodal>
</ng-template>
